import React from "react";
import { cancelIcon, editIcon, walletIcon } from "../../../../Base/SVG";

export default function Network() {
  return (
    <div className="guides">
      <h5>
        <span className="orange"></span> Network setup
      </h5>
      <div className="guides__text">
        <p>
          To create invoices, you need to select and configure the networks in
          which you want to accept payments.
        </p>
        <p>
          Select
          <button className="button box">
            {walletIcon}
            <span>Wallets</span>
          </button>
          from the side menu.
        </p>
        <p>
          On the first visit, all networks will be inactive, an instruction is
          displayed.
        </p>
        <p>
          Select the network you are interested in by activating the switch
          opposite the name.
        </p>
        <p>
          Then also activate the switches opposite the tokens you want to accept
          - only the selected tokens will be available when the invoice is
          redeemed.
        </p>
        <p>
          Please note that tokens are fixed at the time of invoice creation,
          i.e. if, after creating the invoice, you decide to connect other
          tokens, when paying off the invoice, only the tokens selected before
          the invoice were created will be available.
        </p>
        <p>
          Save the changes by clicking on{" "}
          <a href="#" className="button primary">
            Save
          </a>
        </p>
        <p>
          If necessary, you can change the wallet address to which you want to
          accept invoices in a specific network.
        </p>
        <p>
          To do this, click on the edit button{" "}
          <div className="input wIcon">
            <input disabled={true} type="text" placeholder="0x0351d...a7yf1" />
          </div>
        </p>
        <p>
          in the address bar and paste the desired wallet address, then click
          <a href="#" className="button primary">
            Save
          </a>
        </p>
      </div>
    </div>
  );
}
